import * as titleStyles from '../../styles/admissions/admissions.module.scss';
import PropTypes from 'prop-types';

import React from 'react';
import clsx from 'clsx';
import {getDate} from '../../utils/parsing';

const Title = React.memo(function Title ({
  label, subtitle, color, date, lang, id, infos
}) {
  let displayLang = '';
  if (lang) {
    displayLang = lang.toLowerCase();
  }

  const conditionalAttrLink = {};

  if (id) {
    conditionalAttrLink.id = id;
  }


  const parsedDate = getDate(date, '.');
  return (
    <div
      className={clsx(titleStyles.rootTitle, {
        [titleStyles.titleRed]: color === 'RED', [titleStyles.titleBlack]: color !== 'RED'
      })}
      style={color === 'RED'
        ? {backgroundColor: 'var(--red-color)', color: 'var(--white-color)'} : {backgroundColor: 'var(--white-color)'}}
    >
      {date && (
        <div
          className={titleStyles.dateContent}
        >
          <p className={titleStyles.date}>
            {parsedDate}
          </p>
        </div>)}
      <div
        className={clsx(titleStyles.labelContent, titleStyles.espacementTitreBarre)}
      >
        {lang ? (
          <h1
            className={titleStyles.label}
            lang={displayLang}
            {...conditionalAttrLink}
          >
            {label}
          </h1>
        ) : (
          <h1
            className={titleStyles.label}
            {...conditionalAttrLink}
          >
            {label}
          </h1>
        )}
      </div>
      {(label || subtitle) && (
        <div className={titleStyles.dividerContent}>
          <div className={titleStyles.dividerContentItem}>
            <div
              className={clsx(titleStyles.espacementTitreBarre, titleStyles.horizontalBar)}
              style={color === 'RED' ? {backgroundColor: 'var(--white-color)'} : {backgroundColor: 'var(--red-color)'}}
            >
            </div>
          </div>
        </div>
      )}
      {subtitle && (
        <div className={titleStyles.subtitleContent}>
          {lang ? (
            <p
              className={titleStyles.subtitle}
              lang={displayLang}
            >
              {subtitle}
            </p>
          ) : (
            <p
              className={titleStyles.subtitle}
            >
              {subtitle}
            </p>
          )}
        </div>)}
      {infos &&
        <div className={titleStyles.infoContent}>
          {infos.map((info, index) => (
            <div className={titleStyles.infoDiv}
              key={index + '-infos'}
            >
              {info}
            </div>
          ))}
        </div>
      }
    </div>);
});

Title.propTypes = {
  color: PropTypes.oneOf(['RED', 'BLACK']),
  date: PropTypes.string,
  id: PropTypes.string,
  infos: PropTypes.string,
  label: PropTypes.string.isRequired,
  lang: PropTypes.string,
  subtitle: PropTypes.string,
};

export default Title;
